/* ========================================================================
   Cookie popup
 ========================================================================== */

app.cookiePopup = (function () {
  'use strict';

  function loadPopupScript() {
    const container = document.getElementById('cookiePopup');

    if (container) {
      const src = container.dataset.src;
      const version = container.dataset.version;

      let js = document.createElement('script');
      js.id = 'ccpopup-js-init';
      js.defer = 'true';
      js.src = src;
      js.dataset.version = version;

      container.appendChild(js);
    } else {
      console.log('Cookie popup: container is missing!');
    }
  }

  function open() {
    if (typeof ccPopup !== 'undefined') {
      ccPopup.open();
    }
  }

  function init() {
    // Remove if-statement when Data Layer events should be used
    loadPopupScript();
  }

  // Expose public functions and variables
  return {
    init: init,
    open: open,
  };
})();
